import { render, staticRenderFns } from "./ManageArchiveTemplate.vue?vue&type=template&id=5c1df820&scoped=true"
import script from "./ManageArchiveTemplate.vue?vue&type=script&lang=js"
export * from "./ManageArchiveTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1df820",
  null
  
)

export default component.exports